import { PhasrSidePanelController } from '../controller/PhasrSidePanelController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { BehavioralProfileSpecific, RuleTriggerSpecific } from '../types/types';

export class PhasrSidePanelComponent extends BaseWebComponentElement {
  private _titleText: string;
  private _componentType: string;
  private _hasBackButton: boolean;
  private _companyId: string;
  private _componentSpecificData: RuleTriggerSpecific | BehavioralProfileSpecific;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrSidePanelController,
    });
  }

  get titleText(): string {
    return this._titleText ?? '';
  }

  set titleText(value: string) {
    this._titleText = value;
  }

  get componentType(): string {
    return this._componentType ?? '';
  }

  set componentType(value: string) {
    this._componentType = value;
  }

  get hasBackButton(): boolean {
    return this._hasBackButton ?? false;
  }

  set hasBackButton(value: boolean) {
    this._hasBackButton = value;
  }

  get companyId(): string {
    return this._companyId ?? '';
  }

  set companyId(value: string) {
    this._companyId = value;
  }

  get componentSpecificData(): any {
    return this._componentSpecificData ?? {};
  }

  set componentSpecificData(value: any) {
    this._componentSpecificData = value;
  }


}
